import './header.scss';
import AOS from 'aos';
import MmenuLight from 'mmenu-light';

export default async () => {
	const menuHolder = document.querySelector( '#nav' );

	if ( menuHolder ) {
		const menu = new MmenuLight(
			menuHolder,
			'(max-width: 1023px)',
		);

		menu.navigation( {
			selected: 'is-active',
			title: 'Menu',
			theme: 'dark',
		} );

		const drawer = menu.offcanvas( {
			position: 'left',
		} );

		document.querySelector( 'a[href="#nav"]' ).addEventListener( 'click', ( event ) => {
			event.preventDefault();
			drawer.open();
		} );
	}

	let $clickable = $( 'clickable' );
	let $changeable = $( 'changeable' );

	$clickable.click( function () {
		$clickable.not( this ).removeClass( 'active' );
		$( this ).toggleClass( 'active' );
		let index = $clickable.index( this );

		$changeable.not( $( $changeable[ index ] ) ).removeClass( 'open' );
		$( $changeable[ index ] ).toggleClass( 'open' );
	} );

	// Custom popup implementation
	const searchTrigger = document.querySelector( '.header__search' );
	const searchPopup = document.getElementById( 'search-form' );
	const closeButton = searchPopup.querySelector( '.header__close-btn' );
	const searchInput = searchPopup.querySelector( '#s' );
	const searchButton = searchPopup.querySelector( '#searchsubmit' );
	const focusableElements = [
		searchInput,
		searchButton,
		closeButton,
	];

	// Function to open the popup
	function openSearchPopup () {
		searchPopup.style.display = 'block';
		document.body.classList.add( 'popup-open' );
		searchInput.focus();

		// Add event listener for tab key to trap focus
		document.addEventListener( 'keydown', handleTabKey );
		// Add event listener for escape key to close popup
		document.addEventListener( 'keydown', handleEscapeKey );
	}

	// Function to close the popup
	function closeSearchPopup () {
		searchPopup.style.display = 'none';
		document.body.classList.remove( 'popup-open' );

		// Remove event listeners
		document.removeEventListener( 'keydown', handleTabKey );
		document.removeEventListener( 'keydown', handleEscapeKey );

		// Return focus to the search trigger
		searchTrigger.focus();
	}

	// Handle tab key to trap focus inside the popup
	function handleTabKey ( e ) {
		if ( e.key === 'Tab' ) {
			const {
				activeElement,
			} = document;
			const currentIndex = focusableElements.indexOf( activeElement );

			if ( e.shiftKey ) {
				// If shift+tab is pressed, focus the previous element or loop to the last
				if ( currentIndex === 0 || currentIndex === -1 ) {
					e.preventDefault();
					focusableElements[ focusableElements.length - 1 ].focus();
				}
			} else {
				// If tab is pressed, focus the next element or loop to the first
				if ( currentIndex === focusableElements.length - 1 || currentIndex === -1 ) {
					e.preventDefault();
					focusableElements[ 0 ].focus();
				}
			}
		}
	}

	// Handle escape key to close the popup
	function handleEscapeKey ( e ) {
		if ( e.key === 'Escape' ) {
			closeSearchPopup();
		}
	}

	// Add click event to search trigger
	searchTrigger.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		openSearchPopup();
	} );

	// Add click event to close button
	closeButton.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		closeSearchPopup();
	} );

	// Close when clicking outside the popup
	searchPopup.addEventListener( 'click', function ( e ) {
		if ( e.target === searchPopup ) {
			closeSearchPopup();
		}
	} );

	// Aos
	AOS.init( {
		once: true,
		offset: 100,
		duration: 800,
	} );
	let scrollRef = 0;

	window.addEventListener( 'scroll', function () {
		scrollRef <= 10 ? scrollRef++ : AOS.refresh();
	} );
};
